import React from "react";
import { Button } from "./ui/button";

const AboutSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById("cta");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <div className="inline-block">
              <div className="h-1 w-16 bg-blue-600 mb-4"></div>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
              Dedicated To Excellence In Everything We Do.
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              With a focus on professionalism, trust, and attention to detail, we provide complete 
              solutions designed to save you time and bring peace of mind. Our mission is simple: 
              to exceed expectations and build lasting relationships through consistent results and 
              personalized care.
            </p>
            <Button 
              onClick={scrollToContact}
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg rounded-md mt-6"
            >
              Contact
            </Button>
          </div>

          {/* Right Content */}
          <div className="space-y-8">
            {/* Owners Photo */}
            <div className="relative rounded-lg overflow-hidden shadow-xl">
              <img
                src="https://customer-assets.emergentagent.com/job_flooring-solutions-3/artifacts/5qeih51q_25485.jpg"
                alt="Manuel Epoxy Floors Owners"
                className="w-full h-auto object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                <p className="text-white text-lg font-semibold">Meet Our Owners</p>
                <p className="text-white/90 text-sm">Dedicated to Quality & Excellence</p>
              </div>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg shadow-md">
              <h3 className="text-2xl font-bold mb-4 text-gray-900">About Us</h3>
              <p className="text-gray-600 leading-relaxed">
                <span className="font-bold text-gray-900">Manuel Epoxy Floors</span> specializes in 
                professional epoxy flooring solutions and custom concrete coatings for residential and 
                commercial properties. We focus on delivering durable, high-quality finishes with attention 
                to detail, modern aesthetics, and long-lasting performance. Our goal is to enhance and 
                protect floors with reliable workmanship and professional results.
              </p>
            </div>

            <div className="bg-blue-600 text-white p-8 rounded-lg shadow-md text-center">
              <div className="text-6xl font-bold mb-2">+15</div>
              <div className="text-xl font-medium">Years of experience</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;